import { render, staticRenderFns } from "./DetalhesCalculo.vue?vue&type=template&id=30b750af&scoped=true&"
import script from "./DetalhesCalculo.vue?vue&type=script&lang=js&"
export * from "./DetalhesCalculo.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesCalculo.vue?vue&type=style&index=0&id=30b750af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b750af",
  null
  
)

export default component.exports